import React from 'react';
import PropTypes from 'prop-types';
import useSortArray from './sort-array-hook';
import NewHeaderCell from './new-header-cell';

const NewSortableTableHeader = React.forwardRef(({
  array, setArray, columns, initialColumn,
}, ref) => {
  const [sortColumn, setSortColumn] = React.useState(initialColumn);
  const [order, setOrder] = React.useState('desc');
  const { sortBy } = useSortArray({
    setter: setArray,
    keys: columns.map(d => d.key),
  });

  const sort = () => sortBy[sortColumn](order)(array);

  React.useImperativeHandle(ref, () => ({ sort }));

  return (
    <React.Fragment>
      {columns.map(({ name, key }) => {
        name = name || key;
        const props = { name };
        props.onSort = direction => {
          sortBy[key](direction)(array);
          setSortColumn(key);
          setOrder(direction);
        };
        props.order = sortColumn === key ? order : false;
        return <NewHeaderCell {...props} key={key} />;
      })}
    </React.Fragment>
  );
});

NewSortableTableHeader.displayName = 'NewSortableTableHeader';

NewSortableTableHeader.propTypes = {
  array: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setArray: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string,
  })).isRequired,
  initialColumn: PropTypes.string.isRequired,
};

export default NewSortableTableHeader;
